namespace PaperTrail.NewsletterControl {
    export interface StyleSheetForm {
        Title: Serenity.StringEditor;
        Font: Serenity.StringEditor;
        FontSize: Serenity.IntegerEditor;
        TextAlignment: Serenity.StringEditor;
        Height: Serenity.IntegerEditor;
        Width: Serenity.IntegerEditor;
        Padding: Serenity.StringEditor;
        Margin: Serenity.StringEditor;
        Rows: Serenity.IntegerEditor;
        Columns: Serenity.StringEditor;
        Rotation: Serenity.IntegerEditor;
        BackgroundColor: Serenity.StringEditor;
        ForeColor: Serenity.StringEditor;
        IsUnderline: Serenity.BooleanEditor;
        IsBold: Serenity.BooleanEditor;
        IsItalic: Serenity.BooleanEditor;
    }

    export class StyleSheetForm extends Serenity.PrefixedContext {
        static formKey = 'NewsletterControl.StyleSheet';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!StyleSheetForm.init)  {
                StyleSheetForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.BooleanEditor;

                Q.initFormType(StyleSheetForm, [
                    'Title', w0,
                    'Font', w0,
                    'FontSize', w1,
                    'TextAlignment', w0,
                    'Height', w1,
                    'Width', w1,
                    'Padding', w0,
                    'Margin', w0,
                    'Rows', w1,
                    'Columns', w0,
                    'Rotation', w1,
                    'BackgroundColor', w0,
                    'ForeColor', w0,
                    'IsUnderline', w2,
                    'IsBold', w2,
                    'IsItalic', w2
                ]);
            }
        }
    }
}
